const EMBED_SCRIPT_SRC = process.env.REACT_APP_EMBED_SCRIPT_SRC || "";

export const getEmbedScript = () => {
  return EMBED_SCRIPT_SRC;
};
